import { Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import CarListingPage from '../pages/CarListingPages';
import CarDetailPage from '../pages/CarDetailPage_2';
import AboutPage from '../pages/AboutPage';
import NotFoundPage from '../pages/NotFoundPage';
import DealerVehicleListing from '../pages/DealerVehicleListing';
import DealerPage from '../pages/dealers';
import SellPage from '../pages/sellVehiclePage';
import VehicleSuccessPage from '../pages/VehicleSuccessPage';
import ContactUsPage from '../pages/ContactUsPage';
import CoeDashboardPage from '../pages/CoeDashboard';
import ArticlePage from '../pages/ArticlePage';
import ArticleSinglePage from '../pages/ArticleSinglePage';

// ✅ Newly added pages
import TermsPage from '../pages/TermsPage';
import PrivacyPage from '../pages/PrivacyPage';

// ✅ New Vehicles Pages
import NewCarListingPage from '../pages/NewCarListingPage';
import NewCarDetailPage from '../pages/NewCarDetailPage';

// ✅ AI Landing Page
import AiLandingPage from '../pages/AiLandingPage';
import AiQuickMatch from '../components/AiQuickMatch';


interface AppRoutesProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const AppRoutes = ({ mode, setMode }: AppRoutesProps) => {
  return (
    <Routes>
      <Route path="/" element={<HomePage mode={mode} setMode={setMode} />} />
      <Route path="/home" element={<HomePage mode={mode} setMode={setMode} />} />
      <Route path="/login" element={<LoginPage />} />
      
      {/* ✅ Used Commercial Vehicles (Old /vehicle-listing removed) */}
      <Route path="/used-vehicles" element={<CarListingPage mode={mode} setMode={setMode} />} />
      <Route path="/used-vehicle-details/:id" element={<CarDetailPage mode={mode} setMode={setMode} />} />
      
      {/* ✅ New Commercial Vehicles */}
      <Route path="/new-vehicles" element={<NewCarListingPage />} />
      <Route path="/new-vehicle-details/:id" element={<NewCarDetailPage mode={mode} setMode={setMode} />} />

      {/* ✅ Verified Dealers (Old /dealer-vehicles removed) */}
      <Route path="/dealers" element={<DealerPage mode={mode} setMode={setMode} />} />
      <Route path="/dealers/:id" element={<DealerVehicleListing mode={mode} setMode={setMode} />} />
      
      <Route path="/about" element={<AboutPage mode={mode} setMode={setMode} />} />
      <Route path="/sell-vehicle" element={<SellPage mode={mode} setMode={setMode} />} />
      <Route path="/vehicle-success" element={<VehicleSuccessPage mode={mode} setMode={setMode} />} />
      <Route path="/contact-us" element={<ContactUsPage mode={mode} setMode={setMode} />} />
      <Route path="/coe-dashboard" element={<CoeDashboardPage mode={mode} setMode={setMode}/>} />
      <Route path="/articles" element={<ArticlePage />} />
      <Route path="/articles/:id" element={<ArticleSinglePage />} />
      <Route path="/ai-finder" element={<AiLandingPage />} />

      {/* ✅ Newly added routes */}
      <Route path="/Terms" element={<TermsPage mode={mode} setMode={setMode} />} />
      <Route path="/Privacy" element={<PrivacyPage mode={mode} setMode={setMode} />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;